/**
 * Map /page.html → /page before React Router runs so routes match the same
 * components react-snap used for /page (output: build/page/index.html).
 * Also maps /index.html → / for the root route.
 *
 * Without this, /landing.html falls through to the * route and renders the wrong page.
 */
export function normalizeHtmlExtensionPath() {
  if (typeof window === 'undefined') return;
  const { pathname, search, hash } = window.location;
  if (!pathname.endsWith('.html')) return;

  let next;
  if (pathname === '/index.html') {
    next = '/';
  } else {
    next = pathname.slice(0, -5) || '/';
    if (!next.startsWith('/')) next = `/${next}`;
  }

  window.history.replaceState(window.history.state, '', `${next}${search}${hash}`);
}
